export default "__VITE_ASSET__3e4580a9__"